import { BRANDING_COLOR } from '../../constants'
import { getCurrentConfiguration } from '../../selectors/config'
import { getQrReceiptsUrl } from '../../selectors/menus'
import {
  getCharityDescription,
  getCharityImage,
  getCharityName,
  getCharityOptions,
  getCharityOptionsEnabled,
  getCurrentMenu,
  getCurrentStand,
  getEmailReceiptsEnabled,
  getRoundUpForCharityEnabled,
  getTextReceiptsEnabled,
} from '../../selectors/menus'
import { getPrintingEnabled } from '../../selectors/printer'
import { getDefaultTipEnabled } from '../../selectors/revenueCenter'
import { getAccessToken, getDeviceId, getDeviceSerial } from '../../utils/deviceData'
import Environment from '../../utils/environment'
import { invoiceNumberPrefix } from '../../utils/orderNumbers'
import { VNCONFIGS_FEATURE_ENABLEMENT_KEYS } from '../../VNConfigurations/Enums'
import { isFeatureOn } from '../../VNConfigurations/Selectors'
import { setTempCFDScreen } from '../../VNCustomerFacingDisplay/ActionCreators'
import { CFD_SCREEN } from '../../VNCustomerFacingDisplay/Reducer'
import { getCfdWebViewLoaded } from '../../VNCustomerFacingDisplay/Selectors'
import { sendDeviceConfigCFD, sendInitializeCFD } from '../bridgeCalls/VNWebSDKDataSend'
import { getAndroidSDKVersion } from '../Selectors'
import { isSDKCompatible } from '../Utils'

const MIN_ON_PAIR_SEND_INIT_DATA = '2.19.2'

export const configureCfdOnLoad = (state, dispatch, response) => {
  const androidSDKVersion = getAndroidSDKVersion(state)

  const isCfdWebViewLoaded = getCfdWebViewLoaded(state)
  const isCompatible = isSDKCompatible(androidSDKVersion, MIN_ON_PAIR_SEND_INIT_DATA)

  if (!isCfdWebViewLoaded || !isCompatible) return

  const currentStand = getCurrentStand(state)
  const printingEnabled = getPrintingEnabled(state)
  const textReceiptsEnabled = getTextReceiptsEnabled(state)
  const emailReceiptsEnabled = getEmailReceiptsEnabled(state)
  const accessToken = getAccessToken()
  const deviceConfiguration = getCurrentConfiguration(state)
  const currentMenu = getCurrentMenu(state)
  const roundUpForCharityEnabled = getRoundUpForCharityEnabled(state)
  const charityOptionsEnabled = getCharityOptionsEnabled(state)
  const charityDescription = getCharityDescription(state)
  const charityOptions = getCharityOptions(state)
  const charityImage = getCharityImage(state)
  const charityName = getCharityName(state)
  const qrReceiptsUrl = getQrReceiptsUrl(state)
  const configurationUuid = deviceConfiguration?.uuid
  const defaultTipEnabled = getDefaultTipEnabled(state)

  // if the device re-pairs, let the L1400 send over initialization var's again.
  const initializationValues = {
    title: currentStand?.name,
    color: BRANDING_COLOR,
    deviceId: getDeviceId(),
    serialNumber: getDeviceSerial(),
    appConfigurationDeviceId: configurationUuid,
    accessToken: accessToken,
    printingEnabled: printingEnabled,
    textReceiptsEnabled: textReceiptsEnabled,
    emailReceiptsEnabled: emailReceiptsEnabled,
    invoiceNumberPrefix: invoiceNumberPrefix(),
    charitySettings: {
      roundUpForCharityEnabled,
      charityOptionsEnabled,
      charityDescription,
      charityOptions,
      charityImage,
      charityName,
    },
    defaultTipEnabled,
  }
  initializationValues.menuImage = currentMenu?.images?.detail
  initializationValues.image = currentStand?.images?.detail
  initializationValues.enablePosQrCodeReceipts = currentMenu?.enablePosQrCodeReceipts
  initializationValues.qrReceiptsUrl = qrReceiptsUrl

  let { terminalId, storeId, prodUrl, uatUrl, esKey, host, deviceMode } = deviceConfiguration.configuration

  let url = uatUrl

  if (Environment.app.isProduction) {
    url = prodUrl
  }

  const deviceConfig = {
    storeID: storeId,
    terminalID: terminalId,
    esKey,
    host,
    url,
    deviceSubtype: deviceConfiguration.deviceSubtype,
    deviceMode,
  }

  sendDeviceConfigCFD(deviceConfig)
  sendInitializeCFD(initializationValues)
}

export const handleA3700PairingState = (state, dispatch, response) => {
  if (response?.data?.state === CFDCommStates.DISCONNECTED) {
    dispatch(setTempCFDScreen(CFD_SCREEN.SPLIT_PAY_WAITING_FOR_ATTENDANT))
    return
  }

  dispatch(setTempCFDScreen(null))
}

export const CFDCommStates = {
  CONNECTED: 'CONNECTED',
  CONNECTING: 'CONNECTING',
  DISCONNECTED: 'DISCONNECTED',
  UNKNOWN: 'UNKNOWN',
}

export const CFD_COMM_STATE_MIN_VERSION = '2.20.0'

/**
 * Support for soft disconnect detection in APK
 *
 * @link https://shift4.atlassian.net/wiki/spaces/venuenext/pages/2008843016
 *
 * @param {State} state
 * @returns {Boolean}
 */
export const isCommStatesEnabled = (state) => {
  const sdkVersion = getAndroidSDKVersion(state)
  const isFeatureEnabled = isFeatureOn(state, VNCONFIGS_FEATURE_ENABLEMENT_KEYS.CFD_COMM_STATES)

  if (!isFeatureEnabled) return false

  return isSDKCompatible(sdkVersion, CFD_COMM_STATE_MIN_VERSION)
}
